import i18n from '../plugins/i18n'
import _ from 'lodash'

export var ruleRequired = (label) => [
    v => v && !!v.trim() || i18n.t('fieldErrorRequired', { 'field': i18n.t(label) })
]

export var ruleRequiredCover = (label) => [
    v => {
        if (v) return true;
        else return i18n.t('fieldErrorRequired', { 'field': i18n.t(label) });
    }
]

export var ruleValidMin2Max70Characters = (label) => [
    v => {
        if (v) return (v.trim().length > 1 && v.trim().length <= 70) || i18n.t('titleErrorValidNumCharacters', { 'field': i18n.t(label) })
        else return true;
    }
]

export var ruleValidMinMax = (label, min, max) => [
    v => {
        if (!v) return true;
        return v && v.trim().length > min-1 && v.trim().length <= max || i18n.t('minMaxValidator', { 'field': i18n.t(label), 'min': min, 'max': max })
    }
]

export var emailRuleValid = [
    v => v && /.+@.+/.test(v) || i18n.t('emailErrorValid')
]

export var passwordRuleValid = [
    //v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(v) || "Min. 8 characters with at least one capital letter, a number and a special character."
    v => v && /^(?=.{8,})(?=.*[!@#$%^&*^~(){}:;></|`_=+\-'",.?[\]\\])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*^~(){}:;></|`_=+\-'",.?[\]\\]+$/.test(v) || i18n.t('passwordErrorValid')
]

export var passwordRuleCharactersValid = [
    //v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(v) || "Min. 8 characters with at least one capital letter, a number and a special character."
    v => v && /^[A-Za-z0-9!@#$%^&*^~(){}:;></|`_=+\-'",.?[\]\\]*$/.test(v) || i18n.t('passwordErrorValidCharacters')
]

export var spaceURLRuleCharactersValid = [
    v => v && /^[A-Za-z0-9_-]*$/.test(v) || i18n.t('createSpaceErrorURLValidCharacters')
]
export var websiteURLRuleCharactersValid = [
    v => v && /^[A-Za-z0-9_-]*$/.test(v) || i18n.t('webSiteErrorURLValidCharacters')
]
export var ruleValidMin2Characters = (label) => [
    v => v && v.trim().length > 1 || i18n.t('nameErrorValidNumCharacters', { 'field': i18n.t(label) })
]
export var ruleValidMinCharacters = (label, length) => [
    v => v && v.trim().length > (length-1) || i18n.t('nameErrorValidNumCharactersLength', { 'field': i18n.t(label), 'length': length })
]
export var ruleEmptyOrMin2Characters = (label) => [
    v => !v || v.trim().length > 1 || i18n.t('nameErrorValidNumCharacters', { 'field': i18n.t(label) })
  ];
export var phoneNumberRules = [
    v => v && /^[0-9]{10}$/.test(v) || i18n.t('phoneNumberErrorValidCharacters')
];

export var phoneNumberRules2 = [
    v => {
        if (!v) return true;
        return v && /^(\+|00)\d{0,}$/.test(v) || i18n.t('phoneNumberErrorValidCharacters2')
    }
];


export var descriptionRuleValidMin = [
    v => {
        if (v) return (v.trim().length >= 2) || i18n.t('descriptionErrorValidRangeNumCharacters', { 'field': i18n.t('labelDescription') });
        else return true;
    },
]

export var descriptionRuleValidMax = [
    v => {
        if (v) return (v.trim().length <= 500) || i18n.t('descriptionErrorValidRangeNumCharacters', { 'field': i18n.t('labelDescription') });
        else return true;
    }
]

export var subdomainLRuleCharactersValid = [
    v => v && /^[A-Za-z0-9_-]*$/.test(v) || i18n.t('gettingStartedSpaceErrorURLValidCharacters')

]

export var answerRuleValid = [
    v => v && v.trim().length <= 255 || i18n.t('answerErrorValidNumCharacters', { 'field': i18n.t('labelAnswer') })
]

export var priceRuleValidMax = [
    v => {
        if (v) {
            const priceValue = parseFloat(v.replace(',', '.'));
            return (priceValue >= 0 && priceValue <= 999999) || i18n.t('priceErrorValidRangeNumCharacters');
        } else {
            return true;
        }
    }
]
export var limitParticipantsRuleValidMax = [
    v => {
        if (v) return (_.trimStart(v, "0").trim() >= 0 && _.trimStart(v, "0").trim() <= 999999 ) || i18n.t('participantsErrorValidRangeNumCharacters');
        else return true;
    }
]